import { useQuery } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { LEAD_SOURCES_PATH } from 'src/services/api/lead-sources/lead-sources-path';

export interface IGetLeadSourcesResponseItem {
    label: string;
    type: string;
    landlord_user_id?: number;
}

interface IGetLeadSourcesResponse {
    sources: IGetLeadSourcesResponseItem[];
}

export const useLeadSources = () => {
    return useQuery(
        queryKeys.leadSources,
        async () => {
            const res = await apiClient(LEAD_SOURCES_PATH)
                .json<IGetLeadSourcesResponse>();
            return res.sources;
        }
    );
};
